import { useCallback, useMemo, useState } from 'react';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

const RESET_LABEL_TIMER = 3000;

type ShareData = { clickedState: boolean; buttonLabel: TranslationKey; resolvedUrl: string };
type ShareActions = { afterShare: () => void };
type UseDefaultShareButtonResult = ModelHookResult<ShareData, ShareActions>;
type UseCopyLinkVisibleUrlButton = {
	label: TranslationKey;
	successLabel?: TranslationKey;
	url: string;
};
export function useCopyLinkVisibleUrlButton({
	label,
	successLabel,
	url,
}: UseCopyLinkVisibleUrlButton): UseDefaultShareButtonResult {
	const [clickedState, setClickedState] = useState(false);

	const afterShare = useCallback(() => {
		if (successLabel) {
			setClickedState(true);
			// Timeout to reset the style
			window.setTimeout(() => {
				setClickedState(false);
			}, RESET_LABEL_TIMER);
		}
	}, [setClickedState, successLabel]);

	const buttonLabel = useMemo(
		() => (successLabel && clickedState ? successLabel : label),
		[clickedState, successLabel, label],
	);

	const { resolveUrl } = useUtilityContext();
	const resolvedUrl = useMemo(() => {
		return resolveUrl(url);
	}, [url, resolveUrl]);

	return {
		data: { clickedState, buttonLabel, resolvedUrl },
		actions: { afterShare },
	};
}
